import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageview } from "../lib/beacon";

/**
 * Hook usado uma única vez no App root — dispara pageview a cada mudança de
 * rota. Roda também na primeira montagem (visita direta).
 */
export const useRouteBeacon = () => {
  const location = useLocation();
  useEffect(() => {
    trackPageview();
  }, [location.pathname, location.search]);
};
